import React from 'react';
import _ from 'lodash'

import { areAnglesWithin } from '../are_angles_within.js'

import ExperienceElEje from './experiences/ElEje.jsx'
import ExperienceElTodo from './experiences/ElTodo.jsx'
import ExperienceDecision from './experiences/Decision.jsx'
import ExperienceElCambio from './experiences/ElCambio.jsx'
import ExperienceSincronia from './experiences/Sincronia.jsx'
import ExperienceIntuicion from './experiences/Intuicion.jsx'
import ExperienceAceptacion from './experiences/Aceptacion.jsx'
import ExperienceCaos from './experiences/Caos.jsx'

const OPTIONS = [
	['El eje',      -1.5707963267948966, 	ExperienceElEje],
	['El todo',     -0.7853981633974483, 	ExperienceElTodo],
	['Aceptación',   0, 					ExperienceAceptacion],
	['Intuición',    0.7853981633974483, 	ExperienceIntuicion],
	['Sincronía',    1.5707963267948966, 	ExperienceSincronia],
	['Caos',         2.356194490192345, 	ExperienceCaos],
	['Decisión',     3.141592653589793, 	ExperienceDecision],
	['El cambio',    3.9269908169872414, 	ExperienceElCambio]
]

// TODO rename to experienceBy
const optionByAngle = angle => {
	return _.findIndex(OPTIONS, ([option_name, option_angle]) => {
		return areAnglesWithin(angle, option_angle)
	})
}

const optionPathByIndex = (option_index)=>{
	return _.snakeCase(OPTIONS[option_index][0])
}

const optionIndexByPath = (option_path)=>{
	return _.findIndex(OPTIONS, ([option_name]) => { return _.snakeCase(option_name) == option_path })
}


const OptionLabel = ({ option_index, cover_w, cover_h, center_x, center_y, onEnter })=>{
	const [option_name, option_angle] = OPTIONS[option_index]

	// TODO why ?
	const wfix = (window.innerWidth > 1270) ? 0.1* cover_w : 0

	const left = center_x + 0.40 * (cover_w + wfix) * Math.cos(option_angle)
	const top = center_y + 0.462 * cover_h * Math.sin(option_angle)

	return (<p
				className={`
					absolute
					-translate-x-1/2
					-translate-y-1/2
					font-cinzel
					text-white
					text-xs md:text-xl xl:text-4xl
					fixed
					text-shadow-strong
					select-none
					cursor-default
					drop-shadow-2xl
					antialiased
					`
				}
				style={{
					left: `${left}px`,
					top: `${top}px`
				}}
			>{option_name}</p>)
}

export default OptionLabel

export { optionByAngle, OPTIONS, OptionLabel, optionPathByIndex, optionIndexByPath }